import { RouteRecordRaw } from 'vue-router';
import { ROUTE_NAME } from '@constants';
import auth from '@infra/router/module/auth';
import clubIntroduction from '@infra/router/module/club-introduction';
import reservation from '@infra/router/module/reservation';
import facility from '@infra/router/module/facility';
import useInformation from '@infra/router/module/use-information';
import community from '@infra/router/module/community';

const routes: RouteRecordRaw[] = [
  {
    name: 'PaySmartro',
    path: '/smartro',
    component: () => import('@views/PaySmartro.vue'),
    meta: {
      // layout: 'ClearLayout',
    },
  },
  {
    name: 'PayKS',
    path: '/ksnet',
    component: () => import('@views/PayKS.vue'),
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: 'PayKSResult',
    path: '/ksnet-result',
    component: () => import('@views/PayKSResult.vue'),
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: 'Test',
    path: '/test',
    component: () => import('@views/Test.vue'),
    meta: {},
  },
  {
    name: 'Intro',
    path: '/intro',
    component: () => import('@views/Intro.vue'),
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: ROUTE_NAME.Main,
    path: '/',
    component: () => import('@views/Index.vue'),
    meta: {
      hasSectionTitle: false,
    },
  },
  {
    name: ROUTE_NAME.RepairHomepage,
    path: '/repairs',
    component: () => import('@views/RepairHomepage.vue'),
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: 'realNameReceivePopup',
    path: '/real-name-certificate/popup/:successFlag',
    component: () => import('@views/RealNameReceivePopup.vue'),
    props: true,
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: ROUTE_NAME.NotFound,
    path: '/:pathMatch(.*)*',
    component: () => import('@views/NotFound.vue'),
    meta: {
      layout: 'ClearLayout',
      hasSectionTitle: false,
    },
  },
  {
    name: ROUTE_NAME.ServiceTerms,
    path: '/service-terms',
    component: () => import('@views/copyright/ServiceTerms.vue'),
    meta: {
      breadcrumb: true,
      breadcrumbName: '이용약관',
    },
  },
  {
    name: ROUTE_NAME.PrivacyTerms,
    path: '/privacy-terms',
    component: () => import('@views/copyright/PrivacyTerms.vue'),
    meta: {
      breadcrumb: true,
      breadcrumbName: '개인정보처리방침',
    },
  },
  {
    name: 'PrivacyTerms141201',
    path: '/privacy-terms/141201',
    component: () => import('@views/copyright/PrivacyTerms141201.vue'),
    meta: {
      breadcrumb: true,
      breadcrumbName: '개인정보처리방침',
    },
  },
  {
    name: 'PrivacyTerms151201',
    path: '/privacy-terms/151201',
    component: () => import('@views/copyright/PrivacyTerms151201.vue'),
    meta: {
      breadcrumb: true,
      breadcrumbName: '개인정보처리방침',
    },
  },
  {
    name: 'PrivacyTerms220601',
    path: '/privacy-terms/220601',
    component: () => import('@views/copyright/PrivacyTerms220601.vue'),
    meta: {
      breadcrumb: true,
      breadcrumbName: '개인정보처리방침',
    },
  },
  {
    name: ROUTE_NAME.VideoInformation,
    path: '/video-information',
    component: () => import('@views/copyright/VideoInformation.vue'),
    meta: {
      breadcrumb: true,
      breadcrumbName: '영상정보처리기기 운영방침',
    },
  },
  {
    name: ROUTE_NAME.PrivacyEmail,
    path: '/privacy-email',
    component: () => import('@views/copyright/PrivacyEmail.vue'),
    meta: {
      breadcrumb: true,
      breadcrumbName: '이메일무단수집거부',
    },
  },
  auth,
  clubIntroduction,
  reservation,
  facility,
  community,
  useInformation,
];

export default routes;
